<template>
  <div class="apex">
    <apexchart v-if="data!=[]"
               :options="chartOptions"
               :series="data.series"
               type="area"></apexchart>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    data: Object | Array,
  },
  name: 'LineChart',
  data() {
    return {
      chartOptions: {},
    }
  },
  mounted() {
    this.chartOptions = {
      chart: {
        type: 'line',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: 'solid',
        opacity: 1,
      },
      stroke: {
        curve: 'straight',
        show: true,
        width: 3,
        // colors: [this.layoutConfig('colors.theme.base.primary')],
      },
      title: {
        text: this.title,
        align: 'left',
        fontSize: '12px',
        fontWeight: 'bold',
      },
      xaxis: {
        show: true,
        categories: this.data.categories,
      },
      yaxis: {
        show: true,
        min: 0,
        // max: function (max) {
        //   return max + 1
        // },
      },
      tooltip: {
        x: {
          show: true,
          // formatter: function (value) {
          //   return moment(value).format('DD MMM')
          // },
        },
        style: {
          fontSize: '12px',
        },
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      noData: {
        text: this.$t('global.noData'),
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
      },
    }
  },
  methods: {},
}
</script> 